import { Label } from "@babackapp/customer-ui/components/label";
import {
  Option,
  OptionAction,
  OptionDescription,
  OptionTitle,
} from "@babackapp/customer-ui/components/option";
import { RadioGroupItem } from "@babackapp/customer-ui/components/radio-group";
import { formatPrice } from "@babackapp/return-widget-components/utils/format-price";
import type { ShippingRateDto } from "@babackapp/private-api-client/generated/requests/types.gen";

type Props = {
  rate: ShippingRateDto;
  currency: string;
};

export function ShippingRateOption({ rate, currency }: Props) {
  const priceAmount = parseFloat(rate.price.amount);
  const priceCents = Math.round(priceAmount * 100);
  const rateCurrency = rate.price.currencyCode ?? currency;

  return (
    <Label htmlFor={`shipping-rate-${rate.handle}`}>
      <Option>
        <OptionTitle>{rate.title}</OptionTitle>
        <OptionDescription>{formatPrice(priceCents, rateCurrency)}</OptionDescription>
        <OptionAction>
          <RadioGroupItem value={rate.handle} id={`shipping-rate-${rate.handle}`} />
        </OptionAction>
      </Option>
    </Label>
  );
}
